/*
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2022-09-14 19:04:08
 * @LastEditors: 
 * @LastEditTime: 2023-03-17 11:02:38
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import $ from 'jquery'
// import i18n from './utils/lang/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import VueI18n from 'vue-i18n'
import en from "./utils/lang/en"
import tw from "./utils/lang/tw"

Vue.use(VueI18n)
Vue.use(ElementUI);
Vue.component(CollapseTransition)
Vue.config.productionTip = false
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en', // 语言标识
  messages: {
    en: en,
    tw: tw
  }
})
// Vue.prototype._i18n = i18n
// Vue.use(i18n)
new Vue({
  router,
  store,
  $,
  i18n,
  render: h => h(App)
}).$mount('#app')
